// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__94vpN","label":"Completed_label__2G0gC"};